import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  buildAuthRequiredRedirectUrl,
  isSignInRequiredMessage,
} from './profileFormUtils';

/**
 * Session / auth error UI for protected account pages.
 *
 * @param {{
 *   message: string;
 *   returnPath?: string;
 *   signInSuffix?: string;
 *   onRetry?: () => void;
 *   retryLabel?: string;
 *   className?: string;
 *   variant?: 'block' | 'inline';
 * }} props
 */
export default function AccountSessionError({
  message,
  returnPath,
  signInSuffix = '',
  onRetry,
  retryLabel = 'Try again',
  className = '',
  variant = 'block',
}) {
  const location = useLocation();
  const redirectPath = returnPath ?? `${location.pathname}${location.search || ''}`;
  const needsSignIn = isSignInRequiredMessage(message);

  const suffixText =
    signInSuffix && String(signInSuffix).trim()
      ? ` again ${String(signInSuffix).trim()}`
      : ' again.';

  const alertClassName =
    variant === 'inline'
      ? 'auth-inline-message auth-inline-message--error account-session-error account-session-error--inline'
      : 'account-page__note account-page__note--danger';

  const blockClassName = [
    'account-session-error-block',
    `account-session-error-block--${variant}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={blockClassName}>
      <p className={alertClassName} role="alert">
        {needsSignIn ? (
          <>
            Please{' '}
            <Link
              to={buildAuthRequiredRedirectUrl(redirectPath, { reauth: true })}
              className="account-session-error__link"
            >
              sign in
            </Link>
            {suffixText}
          </>
        ) : (
          message
        )}
      </p>
      {onRetry && !needsSignIn ? (
        <button type="button" className="account-session-error__retry" onClick={onRetry}>
          {retryLabel}
        </button>
      ) : null}
    </div>
  );
}
